import React from "react";

import { Link } from "@/i18n/routing";
import ArrowIcon from "@/icons/ui/navigation/arrow.svg";
import { cn } from "@/utils/cn";

import { BreadcrumbItem } from "./types";

interface Props {
  className?: string;
  items: BreadcrumbItem[];
  variant?: "default" | "light";
}

export const Breadcrumbs: React.FC<Props> = ({
  items,
  className,
  variant = "default",
}) => {

  return (
    <div
      className={cn(
        "flex flex-wrap items-center gap-4 text-[1.3rem]",
        className,
        {
          "text-gray-700": variant === "default",
          "text-white": variant === "light",
        },
      )}
    >
      {items?.map((item, index) => (
        <React.Fragment key={`breadcrumb-${index}-${item.label}`}>
          {item.link ? (
            <Link
              href={{ pathname: item.link !== "/" ? item.link : "/." }}
              className={"first-letter:uppercase link"}
            >
              {item.label}
            </Link>
          ) : (
            <span
              className={cn("first-letter:uppercase font-medium ", {
                "text-gray-1200": variant === "default",
                "text-white": variant === "light",
              })}
            >
              {item.label}
            </span>
          )}
          {index < items.length - 1 && <ArrowIcon className={"arrow-right"} />}
        </React.Fragment>
      ))}
    </div>
  );
};
